import {Box, Button, HStack, Text, useTheme, VStack} from '@chakra-ui/react'
import {faCheck} from '@fortawesome/pro-regular-svg-icons'
import {faBasketShopping} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {ReactNode} from 'react'
import InfoWIcon from './InfoWIcon'
import useTranslation from 'next-translate/useTranslation'

interface Props {
  onClick?: () => void
  deactivated?: boolean
  free?: boolean
  plan: string
  price: number
  customIcon?: ReactNode
  preferred?: boolean
  points: {text: string}[]
  highlighted?: boolean
  pt: number[]
}

const PriceBlock = ({
  onClick,
  deactivated,
  free,
  plan,
  price,
  customIcon,
  points,
  highlighted,
  pt,
}: Props) => {
  const theme = useTheme()
  const {t} = useTranslation('subscription')

  return (
    <Box
      p={1}
      pt={0}
      h='full'
      background={highlighted ? theme.colors.brand.gradientPrimary : theme.colors.transparent}
      borderRadius={theme.radii.big}>
      <VStack spacing={0} m={0} pt={!highlighted ? pt : 0} p={0} h='full'>
        {highlighted && (
          <Text variant='extraSmall' m={0} p={1.5} color={theme.colors.text.basic}>
            {t('subscription_most_selected_offer')}
          </Text>
        )}
        <VStack
          spacing={8}
          w='full'
          p={6}
          background={theme.colors.layers.appLevel2}
          borderRadius={theme.radii.medium}
          h='full'
          justifyContent='space-between'>
          <VStack w='full' spacing={5}>
            <InfoWIcon
              mainText={
                free
                  ? t('pricing_subscription_free')
                  : price.toString() + t('pricing_block_currency')
              }
              customIcon={customIcon}
              header={plan}
              smallText={free ? undefined : t('pricing_block_month')}
            />
            <VStack align='start' w='full' spacing={3}>
              {points.map((point, index) => (
                <HStack spacing={2.5} key={index}>
                  <FontAwesomeIcon
                    width={15}
                    height={15}
                    icon={faCheck}
                    color={theme.colors.text.light}
                  />
                  <Text color={theme.colors.text.light} variant='small'>
                    {point.text}
                  </Text>
                </HStack>
              ))}
            </VStack>
          </VStack>

          {!deactivated && (
            <Button
              w={['full', null, null, 'auto']}
              variant='primary'
              onClick={onClick}
              rightIcon={free ? undefined : <FontAwesomeIcon icon={faBasketShopping} />}>
              {free ? t('pricing_block_button_return_to_free') : t('pricing_block_button_buy')}
            </Button>
          )}
          {deactivated && (
            <Button variant='primary' disabled w={['full', null, null, 'auto']}>
              {t('pricing_block_button_disabled')}
            </Button>
          )}
        </VStack>
      </VStack>
    </Box>
  )
}

export default PriceBlock
